import type { IntegrationHostName } from '../../contexts/ClientNameContext';
import type {
  TooltipAudience,
  TooltipAudienceContext,
} from '../stores/tooltipStore.types';
import { matchesLocale } from './localeMatching';

/**
 * Returns true if the audience context satisfies all audience criteria.
 * - Empty/omitted audience passes all users.
 */
export function isAudienceMatch(
  audience: TooltipAudience[] | undefined,
  ctx: TooltipAudienceContext
): boolean {
  if (!audience || audience.length === 0) return true;
  return audience.every((criterion) => {
    if (criterion.type === 'language') {
      return criterion.locales.some((locale) =>
        matchesLocale(ctx.browserLanguage, locale)
      );
    }
    if (criterion.type === 'client') {
      const current = ctx.clientName;
      if (!current) return false;
      return criterion.clients.includes(current as IntegrationHostName);
    }
    return true;
  });
}
